import { render, staticRenderFns } from "./bannerAdd.vue?vue&type=template&id=ae00a13e&scoped=true&"
import script from "./bannerAdd.vue?vue&type=script&lang=js&"
export * from "./bannerAdd.vue?vue&type=script&lang=js&"
import style0 from "./bannerAdd.vue?vue&type=style&index=0&id=ae00a13e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae00a13e",
  null
  
)

export default component.exports